'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/standard.js';
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _selectors = require('@marmalade/account/lib/selectors');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _omit = require('lodash/omit');
var _omit2 = _interopRequireDefault(_omit);
var _propTypes = require('prop-types');
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _reduxWindow = require('redux-window');
var _button = require('./base-components/button');
var _button2 = _interopRequireDefault(_button);
var _contactUs = require('./base-components/contact-us');
var _contactUs2 = _interopRequireDefault(_contactUs);
var _seperate = require('./base-components/seperate');
var _seperate2 = _interopRequireDefault(_seperate);
var _withHeaderTheme = require('./hocs/with-header-theme');
var _withHeaderTheme2 = _interopRequireDefault(_withHeaderTheme);
var _standardEmpty = require('./standard-empty');
var _standardEmpty2 = _interopRequireDefault(_standardEmpty);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

// A white bar with optional live chat and telephone icon & a log out button if logged in

var Standard = function (_Component) {
  _inherits(Standard, _Component);
  function Standard() {
    _classCallCheck(this, Standard);
    return _possibleConstructorReturn(this, (Standard.__proto__ || Object.getPrototypeOf(Standard)).apply(this, arguments));
  }
  _createClass(Standard, [{
    key: 'renderItems',
    value: function renderItems() {
      var noTelephone = this.props.noTelephone;
      return !noTelephone ? [_react2.default.createElement(_contactUs2.default, {
        key: 'telephone',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 37
        },
        __self: this
      })] : [];
    }
  }, {
    key: 'renderLogOut',
    value: function renderLogOut() {
      var headerButtonLinkProps = {
        to: this.props.logOutLink
      };
      if (typeof this.props.logOutHref !== 'undefined') {
        headerButtonLinkProps = {
          href: this.props.logOutHref,
          Element: 'a'
        };
      }
      return _react2.default.createElement(_button2.default, Object.assign({
        text: 'Log Out',
        prominence: 'primary',
        css: {
          marginLeft: '1rem'
        }
      }, headerButtonLinkProps, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 51
        },
        __self: this
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var items = this.renderItems();
      return _react2.default.createElement(_standardEmpty2.default, Object.assign({}, (0, _omit2.default)(this.props, ['noTelephone', 'noLiveChat', 'openForBusiness', 'loggedIn']), {
        smallLogo: this.props.width < 450,
        link: this.props.link,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 58
        },
        __self: this
      }), _react2.default.createElement(_glamorous2.default.Div, {
        display: 'flex',
        alignItems: 'center',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 63
        },
        __self: this
      }, _react2.default.createElement(_seperate2.default, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 64
        },
        __self: this
      }, items), this.props.loggedIn && this.renderLogOut()));
    }
  }]);
  return Standard;
}(_react.Component);
Standard.propTypes = {
  theme: _propTypes.object.isRequired,
  noTelephone: _propTypes.bool,
  width: _propTypes.number.isRequired,
  openForBusiness: _propTypes.bool,
  loggedIn: _propTypes.bool,
  logOutLink: _propTypes.string,
  logOutHref: _propTypes.string,
  link: _propTypes.string
};
Standard.defaultProps = {
  openForBusiness: false,
  loggedIn: false,
  logOutLink: '/login',
  logOutHref: undefined
};
exports.default = (0, _withHeaderTheme2.default)((0, _reactRedux.connect)(function (state) {
  return {
    loggedIn: (0, _selectors.isLoggedIn)(state),
    width: (0, _reduxWindow.getWidth)(state)
  };
})(Standard));